export default __webpack_public_path__ + "static/media/goal4.ff0909ae.webp";